/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_ChargeInputs */

const en_new_charge = /** @type {(inputs: New_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Charge`)
};

const es_new_charge = /** @type {(inputs: New_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo cargo`)
};

/**
* | output |
* | --- |
* | "New Charge" |
*
* @param {New_ChargeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const new_charge = /** @type {((inputs?: New_ChargeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_ChargeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_new_charge(inputs)
	return es_new_charge(inputs)
});